import destinationList from '~/js/sections/weddings/includes/destinations-list.js';
const thumbs = Array.from(document.querySelectorAll('#hm-destWrapper .hm-dest-thumb'));
const slideWrap = document.getElementById('hmSlideWrap');
const destDetails = document.getElementById('hm-destDetails');


const showNextImage = () => {
  const $actEl = document.querySelector('li.active');
  const $nextEl = $actEl.nextElementSibling;

  if ($nextEl.tagName === 'LI') {
    $actEl.classList.remove('active');
    $nextEl.classList.add('active');
  } else {
    $actEl.classList.remove('active');
    document.querySelector('.destSlideshow li:first-of-type').classList.add('active');
  }
};
const showPreviousImage = () => {
  const $actEl = document.querySelector('li.active');
  let $prevEl;

  if ($actEl.previousElementSibling === null) {
    $prevEl = document.querySelector('.destSlideshow li:last-of-type');
  } else {
    $prevEl = $actEl.previousElementSibling;
  }
  if ($prevEl.tagName === 'LI') {
    $actEl.classList.remove('active');
    $prevEl.classList.add('active');
  } else {
    $actEl.classList.remove('active');
    document.querySelector('.destSlideshow li:last-of-type').classList.add('active');
  }
};

const showDestination = (target) => {
  thumbs.forEach(thumb => {
    thumb.classList.add('hideThumb');
  });
  const contentID = target.getAttribute('data-dest');
  const targetDest = destinationList[contentID];
  const slideList = `
    <ul class='destSlideshow'>
        <li class='active'>
            <div class='top-container xs-12' style='background-image: url(//cdn.sandals.com/beaches/v12/images/weddings/includes/destinations/det-${targetDest.img}.jpg); background-size: cover; background-position: center;'>
                <div class="resort-name"><h3><i class="icon-logo-Beaches-new"></i> ${targetDest.name}</h3><h4>${targetDest.location}</h4></div>
            </div>
            <p class='xs-12 xl-10 xl-offset-1'>${targetDest.description}</p>
        </li>
        <div class='destNav'><a class='destPrev'><i class='ic ic-button-arrow-prev'></i></a><a class='destNext'><i class='ic ic-button-arrow-next'></i></a></div>
    </ul>`;

  slideWrap.innerHTML = '';
  destDetails.classList.add('showSlide');
  slideWrap.innerHTML = slideList;
};


document.onclick = (event) => {

  const ep = event.target;


  if (!Element.prototype.matches) {
    if (ep.webkitMatchesSelector) {
      ep.matches = ep.webkitMatchesSelector;
    }

    if (ep.msMatchesSelector) {
      ep.matches = ep.msMatchesSelector;
    }

    if (ep.mozMatchesSelector) {
      ep.matches = ep.mozMatchesSelector;
    }
  }


  if (ep.matches('.hm-dest-thumb, .hm-dest-thumb *')) {
    let target;

    if (!ep.matches('.hm-dest-thumb')) {
      target = event.target.parentElement;
      if (!$(target).hasClass('hm-dest-thumb')) {
        target = target.parentElement;
      }
    } else {
      target = event.target;
    }
    showDestination(target);
  }

  if (ep.matches('.destPrev, .destPrev *')) {
    showPreviousImage();

    return false;
  }

  if (ep.matches('.destNext, .destNext *')) {
    showNextImage();

    return false;
  }

  if (ep.matches('.close')) {
    thumbs.forEach(thumb => {
      thumb.classList.remove('hideThumb');
    });
    destDetails.classList.remove('showSlide');
  }

  return true;

};
